import { LwButton } from 'redesign';
import { CheckoutTypeToggle } from 'ogp/components/views/administration/checkouts/checkouts-type-provider';
import { FilterButton } from 'ogp/components/views/administration/shared';
import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import { useCallback } from 'react';

type InboxTableActionsProps = {
  selectedClaimIds: string[];
  onOpenExport: (ids: string[]) => void;
  onOpenSettle: (ids: string[]) => void;
  toggleDrawer: () => void;
  nrOfActiveFilters: number;
};
export const InboxTableActions = ({
  selectedClaimIds,
  onOpenExport,
  onOpenSettle,
  toggleDrawer,
  nrOfActiveFilters,
}: InboxTableActionsProps) => {
  const checkoutInboxExportCallback = useCallback(
    (ids: string[]) => onOpenExport(ids),
    [onOpenExport]
  );

  return (
    <SelectionButtons>
      <LwButton
        disabled={selectedClaimIds.length === 0}
        onClick={() => onOpenSettle(selectedClaimIds)}
        color="primary"
      >
        Akkoord
      </LwButton>
      <LwButton
        disabled={selectedClaimIds.length === 0}
        onClick={() => checkoutInboxExportCallback(selectedClaimIds)}
        color="primary"
      >
        Exporteer
      </LwButton>
      <CheckoutTypeToggle />
      <FilterButton onClick={toggleDrawer} nrOfActiveFilters={nrOfActiveFilters} />
    </SelectionButtons>
  );
};

const SelectionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(4),
  gap: theme.spacing(8),
}));
